import React from 'react';

import {MainLayout} from 'widgets/layout';

import {ServerDetails} from 'features/server';

const ServerDetailsPage: React.FC = () => {
    return (
        <MainLayout>
            <ServerDetails />
        </MainLayout>
    );
};

export default ServerDetailsPage;
